export const NEW_NAV_SECTIONS = {
  marketing: 'marketing',
  inProperty: 'inProperty'
}

export const NEW_NAV_MARKETING_INVITE_CATEGORIES = [
  'AfterLastVisit',
  'Lost3Months',
  'Lost6Months',
  'Lost9Months',
  'Lost12Months',
  'Lost15Months',
  'Lost15MonthsPlus'
]

export const NEW_NAV_MARKETING_INVITE_ADMIN_CATEGORIES = [
  'BookingUpdated',
  'AlreadySubscribed'
]

export const NEW_NAV_MARKETING_TRANSACTIONAL_CATEGORIES = [
  'JustBooked',
  'Cancelled',
  'NoShow',
  'CheckedOutReview'
]

export const NEW_NAV_IN_PROPERTY_TRANSACTIONAL_CATEGORIES = [
  'ServiceStartDayBefore',
  'ServiceStartForPrimaryGuest'
]

const MARKETING_INVITE_SORT_ORDER = [
  'AfterLastVisit',
  'BookingUpdated',
  'AlreadySubscribed',
  'Lost3Months',
  'Lost6Months',
  'Lost9Months',
  'Lost12Months',
  'Lost15Months',
  'Lost15MonthsPlus'
]

const MARKETING_TRANSACTIONAL_SORT_ORDER = [
  'JustBooked',
  'Cancelled',
  'NoShow',
  'CheckedOutReview'
]

const IN_PROPERTY_TRANSACTIONAL_SORT_ORDER = [
  'ServiceStartDayBefore',
  'ServiceStartForPrimaryGuest'
]

export function getNewNavSection(search) {
  const params = new URLSearchParams(search || '')
  const section = params.get('navSection')

  if (section === NEW_NAV_SECTIONS.inProperty) {
    return NEW_NAV_SECTIONS.inProperty
  }

  return NEW_NAV_SECTIONS.marketing
}

export function getAllowedCategoriesForNewNav({ type, navSection, isInternalAdmin }) {
  if (type === 'sales') {
    if (isInternalAdmin) {
      return [
        ...NEW_NAV_MARKETING_INVITE_CATEGORIES,
        ...NEW_NAV_MARKETING_INVITE_ADMIN_CATEGORIES
      ]
    }

    return [...NEW_NAV_MARKETING_INVITE_CATEGORIES]
  }

  if (type === 'service') {
    if (navSection === NEW_NAV_SECTIONS.inProperty) {
      return [...NEW_NAV_IN_PROPERTY_TRANSACTIONAL_CATEGORIES]
    }

    return [...NEW_NAV_MARKETING_TRANSACTIONAL_CATEGORIES]
  }

  return null
}

export function isCampaignVisibleForNewNav({
  category,
  type,
  navSection,
  isInternalAdmin
}) {
  const allowed = getAllowedCategoriesForNewNav({ type, navSection, isInternalAdmin })

  if (!allowed) {
    return true
  }

  return allowed.includes(category)
}

export function getNewNavCampaignSortIndex(category, type, navSection) {
  let order = MARKETING_INVITE_SORT_ORDER

  if (type === 'service') {
    order =
      navSection === NEW_NAV_SECTIONS.inProperty
        ? IN_PROPERTY_TRANSACTIONAL_SORT_ORDER
        : MARKETING_TRANSACTIONAL_SORT_ORDER
  }

  const index = order.indexOf(category)
  return index === -1 ? Number.MAX_SAFE_INTEGER : index
}

export function getManageCampaignsPageTitle({
  isDefaultCampaigns,
  isNewNav,
  navSection,
  type
}) {
  if (isDefaultCampaigns) {
    return 'Default Campaigns'
  }

  if (type === 'drip') {
    return isNewNav ? 'Drip campaign' : 'Drip campaigns'
  }

  if (type === 'sales') {
    return isNewNav ? 'Automated invites' : 'Invite messages'
  }

  if (type === 'service') {
    return isNewNav ? 'Automated transactional' : 'In-property messages'
  }

  if (!isNewNav) {
    return 'Automated messages'
  }

  if (navSection === NEW_NAV_SECTIONS.inProperty) {
    return 'In property messages'
  }

  return 'Marketing messages'
}
